import { Component, OnInit, ViewChild, ElementRef, Input, Signal, effect, ChangeDetectorRef, Type } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NzMessageService } from 'ng-zorro-antd/message';
import { Agent, AgentServicev2 } from '../agent-builder-services/agent.service';
import { KnowledgeBaseService, KnowledgeBase } from '../agent-builder-services/knowledge-base.service';
import { SearchInputNewComponent, SearchProperties } from 'src/app/system-utils/search-input-new/search-input-new.component';
import { LanguageServices } from 'src/app/services/LanguageServices';
import { Variable } from 'src/app/forms/formula-tester/formula-tester.component';
import { BehaviorSubject, Observable, Subject, Subscription } from 'rxjs';
import { FormServices } from 'src/app/services/form.services';
import { ModalOptions, NzModalService } from 'ng-zorro-antd/modal';
import { NzTableComponent } from 'ng-zorro-antd/table';
import { GlobalErrorHandler } from 'src/app/services/GloabalErrorHandler.services';
import { NzTabsComponent } from 'ng-zorro-antd/tabs';
import { UserAuthenticationServices } from 'src/app/services/user-authentication.services';
import { PromptMessage } from '../agent-builder-model/agent-config';
import { AgentBuilderDatabaseComponent } from '../agent-builder-database/agent-builder-database.component';
import { REGISTRY } from 'src/app/interfaces/registry-services';
import { CronFormComponent } from 'src/app/forms/cron-form/cron-form.component';


@Component({
  selector: 'agent-builder-config',
  templateUrl: './agent-builder-config.component.html',
  styleUrls: ['./agent-builder-config.component.scss'],
  standalone: false
})
export class AgentBuilderConfigComponent implements OnInit {

  @ViewChild('fileInput') fileInput!: ElementRef;
  @ViewChild('tableMcp') tableMcp: NzTableComponent<any> = null;
  @ViewChild('tableGoal') tableGoal: NzTableComponent<any>;
  @ViewChild('tableHHeader') tableHHeader: NzTableComponent<any>;
  @ViewChild('tabs') tabs: NzTabsComponent;
  @ViewChild('searchInputIdhook') searchInputIdhook: SearchInputNewComponent;

  mcpForm!: FormGroup;
  loading = false;
  mcpLoading = false;
  kbLoading = false;
  @Input() form:FormGroup
  @Input() editSubject: BehaviorSubject<boolean> | null = null;

  selectedMcps: string[] = [];
  knowledgeBaseFiles: KnowledgeBase[] = [];
  showMcpModal = false;
  editingIndexMcp: number | null = null;
  models = [];
  embeedModels = [];
  modelsData:BehaviorSubject<Object[]> = new BehaviorSubject<Object[]>([]);
  variables:Variable[] = [];
  mcpPageIndex = 1;
  mcps: any[] = [];
  oldForm:Agent;
  listOfTool:any[] = [];
  loadingMcp:boolean = false;
  showSaveButton = true;
  backupSystemPrompt:string = null;
  historySelected:number = -1;
  canRedoSystemPrompt = false;
  filteredListOfTool: any[] = [];
  localSub:Subscription;
  agentModelsSub:Subscription;

  constructor(
    private agentServiceV2: AgentServicev2,
    private uas:UserAuthenticationServices,
    private message: NzMessageService,
    private ls: LanguageServices,
    private formServices:FormServices,
    private fb: FormBuilder,
    private modal: NzModalService,
    
  ) {

  }

  ngOnDestroy(): void {
    if ( this.localSub!=null){
      this.localSub.unsubscribe();
    }
    if ( this.agentModelsSub!=null){
      this.agentModelsSub.unsubscribe();
    }
  }

fixDate(d: any) {
  if (d instanceof Date) {
    return d;
  }

  if (typeof d === 'string' && d.trim() !== '') {
    return new Date(d.replace('BRT', 'GMT-0300'));
  }

  return new Date();
}


selectHistoryPrompt(){
  if ( this.historySelected>-1 ){
    let history:PromptMessage = (this.form.get("systemPromptHistory").value as any[])[this.historySelected]
    this.form.get("systemPrompt").setValue(history.systemPrompt);
  }
}



onChangeTools(event){
    if ( this.searchInputIdhook==null){
      return;
    }
  
    this.loadMcpHook(event.key);
}

loadModels(){
    return new Promise((resolve,reject)=>{
      this.agentModelsSub = this.agentServiceV2.loadLlmModels().subscribe({

        next:(res:any)=>{
            this.modelsData.next(res['SQL']||[]);
            let selectedModel:any = this.modelsData.value.find(m => m['llm'] === this.form.get('llm')?.value);
            if ( selectedModel!= null){
                this.models = selectedModel.models;
                this.embeedModels = selectedModel.embeedModels;
            }
            resolve(true);
          },
        error:(err)=>{
            this.message.error(this.ls.instant("agentBuilder.errorLoadingModels"));
            reject(err);
        }
      });
    })
    
}

loadMcpHook(idHook){
    let filtered = this.searchInputIdhook?.list.filter(f=>f.IDHOOK==idHook);
    this.listOfTool = [];
    this.filteredListOfTool = [];
    if (filtered.length > 0){
      let expression:any = JSON.parse(filtered[0].EXPRESSION);
      if ( expression.services){
        if ( expression.type == "mcp"){
            for ( let service of expression.services){
                let tool = {
                    name: service.serviceName,
                    description: service.description,
                    arguments: service.jsonSchema
                }
                let index = this.listOfTool.findIndex(t=>t.id == (this.mcpForm.get('url')?.value||this.mcpForm.get('idhook')?.value?.key) );
                if ( index == -1 ){
                    this.listOfTool.push({
                        id: (this.mcpForm.get('url')?.value||this.mcpForm.get('idhook')?.value?.key),
                        tools: [tool]
                    });
                }else{
                    this.listOfTool.find(d=>d.id == (this.mcpForm.get('url')?.value||this.mcpForm.get('idhook')?.value.key))?.tools.push(tool);
                }
            }
        }
      }
    }
    
    this.filteredListOfTool = this.listOfTool.filter(d=>d.id == (this.mcpForm.get('url')?.value||this.mcpForm.get('idhook')?.value?.key));
}
ngOnInit(): void {

  setTimeout(async ()=>{
    await this.loadModels();
    this.form.get('llm')?.valueChanges.subscribe(value => {
        this.onLlmChange(value);
    });

    if (!this.form.get('mcps')) {
        this.form.addControl('mcps', []);
    }
    this.mcps =  (this.form.get('mcps')?.value ?? []) as any[];
    this.oldForm = this.form.getRawValue() as Agent;

    if ( this.form.get('_id')?.value){
        this.onLlmChange(this.form.get('llm')?.value);
    }

    if ( this.form.get("systemPrompt").value!= null){
        this.backupSystemPrompt = this.form.get("systemPrompt").value;
    }

    this.form.get('autonomo').valueChanges.subscribe(data=>{
        this.configureForm(data);
    });

    this.configureForm(this.form.get('autonomo').value);
  },100);
}

configureForm(autonomo){
    if ( autonomo ){
            this.form.get('qaTable').disable();
            this.form.get('alTable').enable();
    }else{
            this.form.get('qaTable').enable();
            this.form.get('alTable').disable();
    }
}

ngAfterViewInit(){
    this.tabs.nzSelectedIndexChange.subscribe(index=>{
        if ( index == 5 || index == 6){
            this.showSaveButton = false;
        }else{
            this.showSaveButton = true;
        }
    });

}

get agent(): Agent {
    return this.form.getRawValue() as Agent;
}

getModel(llm):any{
    return this.modelsData.value.find(m => m['llm'] === llm);
}

changeCodeContract:Subject<any> = new Subject<any>();

onChangeCodeCodeContract(evento){
        
    this.searchInputCodeCompany.disabled = true;
    this.searchDBNAME.disabled = true;
    setTimeout(()=>{
        this.searchInputCodeCompany.disabled = false;

        let variable = this.variables.find(d=>d.key=='@CODECONTRACT');

        if ( variable == null){
            this.variables.push({
                key:'@CODECONTRACT',
                value:evento?.key,
                type:'texto'
            });
        }else{
            variable.value = evento?.key;
        }
        
        this.changeCodeContract.next(evento?.key);
        this.searchDBNAME.disabled = false;
    },100);
}

searchWebHook:SearchProperties ={
        entityName:'Mktpwebhook',
        fields:{keyField:'IDHOOK', valueField:'NAME'},
        placeholder:this.ls.instant("IDHOOK"),
        showKey:true,
        size:'default',
        condition: "ACTIVE = 'S'",
        disabled:false
}

searchInputCodeCompany:SearchProperties ={
        entityName:'Mktpcompanies',
        fields:{keyField:'CODECOMPANY', valueField:'NAME'},
        placeholder:this.ls.instant("CODECOMPANY"),
        showKey:true,
        size:'default',
        condition: 'CODECONTRACT = {@CODECONTRACT}',
        disabled:true
}
  
searchInputCodeContract:SearchProperties ={
        entityName:'Mktpcontract',
        fields:{keyField:'CODECONTRACT', valueField:'CONTRACTNAME'},
        placeholder:this.ls.instant("CODECONTRACT"),
        showKey:true,
        size:'default'        
}

searchDBNAME:SearchProperties ={
    entityName:'Mktpmongodatabase',
    fields:{keyField:'_id', valueField:'databasename'},
    placeholder:this.ls.instant("agentBuilder.databasename"),
    showKey:false,
    size:'default',
    condition:"{\"codecontract.key\":{@CODECONTRACT}}",
    disabled:true,
    type:'mongo'
}

onDatabaseSelect(event){
  if ( event== null){
    return;
  }
  
  if ( this.form.get('fbTable')!= null || this.form.get('kbTable')!= null || this.form.get('qaTable')!= null || this.form.get('alTable')!= null || this.form.get('fbVectorIndexName')!= null || this.form.get('kbVectorIndexName')!= null ){
      this.modal.confirm({
          nzTitle: this.ls.instant("agentBuilder.confirmChangeDatabase"),
          nzContent: this.ls.instant("agentBuilder.confirmChangeDatabaseMessage"),
          nzOnOk: ()=>{
              
              this.form.get('fbTable').setValue(event['fbTable']);
              this.form.get('kbTable').setValue(event['kbTable']);
              this.form.get('qaTable').setValue(event['qaTable']);
              this.form.get('alTable').setValue(event['alTable']);
              this.form.get('fbVectorIndexName').setValue(event['fbVectorIndexName']);
              this.form.get('kbVectorIndexName').setValue(event['kbVectorIndexName']);
          }
      });
  }else{
      this.form.get('fbTable').setValue(event['fbTable']);
      this.form.get('kbTable').setValue(event['kbTable']);
      this.form.get('qaTable').setValue(event['qaTable']);
      this.form.get('alTable').setValue(event['alTable']);
      this.form.get('fbVectorIndexName').setValue(event['fbVectorIndexName']);
      this.form.get('kbVectorIndexName').setValue(event['kbVectorIndexName']);
  }
   
  
}

createDatabase(){ 

    this.modal.create({
        nzTitle: this.ls.instant("agentBuilder.createDatabase"),
        nzContent: AgentBuilderDatabaseComponent,
        nzData: {
            codecontract: this.form.get('codecontract')?.value,
        },
        nzCentered: true,
        nzCancelText: this.ls.instant("cancel"),
        nzOkText: this.ls.instant("save"),
        nzWidth: 400,
        nzOnOk: (component) =>{
          return new Promise((resolve) => {

                if (!component.form.valid) {
                    let errors = this.formServices.getFormErrors(component.form,[],"\n", 'agentBuilder');
                    this.message.error(errors);
                    resolve(false);
                    return;
                }

                this.agentServiceV2.createDatabase(component.form.value).subscribe({
                    next: (res) => {
                        this.message.success(this.ls.instant("agentBuilder.databaseCreated"));
                        resolve(true);
                    },
                    error: (err) => {
                        resolve(false);
                        this.message.error(this.ls.instant("agentBuilder.databaseCreationFailed"));
                        
                    }
                });
              });
                
          }
    });

}

onLlmChange(llm): void {

    let selectedModel:any = this.modelsData.value.find(m => m['llm'] === llm);
    if ( selectedModel!= null){
        this.models = selectedModel.models;
        this.embeedModels = selectedModel.embeedModels;
    }
    

}

  /**
   * Inicializa o formulário de MCP
   */
private initMcpForm(): void {
    if ( this.localSub!=null){
      this.localSub.unsubscribe();
    }

    this.mcpForm = this.fb.group({
      idhook:[null],
      url: [''],
      header: [[]],
      tools:[[]],
      local: [false]
    });
}

private applyLocalModeRules(val: boolean, clearOpposite: boolean = true): void {
    this.switchValueMCPMode  = val;

    if ( val ){
        this.mcpForm.get('idhook').setValidators([Validators.required]);
        this.mcpForm.get('url').clearValidators();
        if (clearOpposite) {
          this.mcpForm.get('url').setValue('');
          this.mcpForm.get('tools').setValue([]);
        }
    }else{
        this.mcpForm.get('url').setValidators([Validators.required]);
        this.mcpForm.get('idhook').clearValidators();
        if (clearOpposite) {
          this.mcpForm.get('idhook').setValue(null);
          this.mcpForm.get('tools').setValue([]);
        }
    }

    this.mcpForm.get('idhook').updateValueAndValidity({ emitEvent: false });
    this.mcpForm.get('url').updateValueAndValidity({ emitEvent: false });
}

private startLocalMonitor(): void {
    this.localSub = this.mcpForm.get('local').valueChanges.subscribe(val=>{
        this.applyLocalModeRules(val, true);
    });
}

  /**
   * Abre modal para adicionar novo MCP
   */
openAddMcpModal(): void {
    this.editingIndexMcp = -1;
    this.initMcpForm();
    this.applyLocalModeRules(this.mcpForm.get('local').value, false);
    this.startLocalMonitor();
    this.filteredListOfTool = [];
    this.showMcpModal = true;
}

  getToolNames(group: any) {
    if (!group?.tools?.length) return '-';
    return group.tools.map(t => t.name).join(', ');
  }

  compareTools = (a: any, b: any) => {
    return a && b && a.name === b.name;
  };

  private waitSearchAndLoadMcpHook(idHook: string, attempt: number = 0): void {
    if (!idHook) {
      return;
    }

    if (this.searchInputIdhook?.list?.some(item => item.IDHOOK == idHook)) {
      this.loadMcpHook(idHook);
      return;
    }

    if (attempt >= 20) {
      return;
    }

    setTimeout(() => this.waitSearchAndLoadMcpHook(idHook, attempt + 1), 100);
  }



  editMcp(absoluteIndex: number): void {

    this.editingIndexMcp = absoluteIndex;
    this.initMcpForm();
    this.mcpForm.patchValue(this.mcps[absoluteIndex]);
    this.applyLocalModeRules(this.mcpForm.get('local').value, false);
    this.startLocalMonitor();

    this.filteredListOfTool = this.listOfTool.filter(d=>d.id == (this.mcpForm.get('url')?.value||this.mcpForm.get('idhook')?.value?.key));

    if ( this.mcpForm.get('tools')?.value!= null && this.mcpForm.get('tools')?.value.length > 0){
        //this.listOfTool.push(...this.mcpForm.get('tools')?.value);
        if ( this.filteredListOfTool.length == 0){
          this.listOfTool.push({
              id: (this.mcpForm.get('url')?.value||this.mcpForm.get('idhook')?.value.key),
              tools: this.mcpForm.get('tools')?.value
          });
        }else{
          
          this.listOfTool.find(d=>d.id == (this.mcpForm.get('url')?.value||this.mcpForm.get('idhook')?.value.key))?.tools.concat(this.mcpForm.get('tools')?.value);

        }
        
        this.filteredListOfTool = this.listOfTool.filter(d=>d.id == (this.mcpForm.get('url')?.value||this.mcpForm.get('idhook')?.value.key));        
    }

    this.showMcpModal = true;

    if ( this.mcpForm.get('idhook').value!= null){
      this.waitSearchAndLoadMcpHook(this.mcpForm.get('idhook').value.key);
    }
  }

  formatHeader(header: any[]): string {
    if (!Array.isArray(header) || header.length === 0) return '-';
    return header.map(h => `${h.key}=${h.value}`).join(', ');
  }

  switchValueMCPMode = false;

  loadMcpTools(): void {
    if ( this.mcpForm.get('url').invalid){
        this.message.error('URL é obrigatória');
        return;
    }

    this.loadingMcp = true;

    let header:Record<string,string> = this.mcpForm.get('header').value.reduce((acc, item) => ({ ...acc, [item.key]: item.value }), {})
    this.agentServiceV2.getToolsMcp(this.mcpForm.get('url').value, header, this.agent).then(tools=>{
        if ( tools == null ){
            this.message.warning('Nenhuma ferramenta encontrada na URL informada');
            this.loadingMcp = false;
            return;
        }

        let result = null;
        if ( tools['events']!=null &&  tools['events'][0]!= null){
            result = tools['events'][0]['result'];
        }else{
            result = tools['result'];
        }

        if ( result == null ){
            this.message.warning('Nenhuma ferramenta encontrada na URL informada');
            this.loadingMcp = false;
            return;
        }
        
        for ( let tool of result['tools'] as any[]){

            let toolNormalized = null;
            if (typeof tool === 'string') {
              toolNormalized =  { name: tool };
            }else{
              toolNormalized = tool;
            }
            

            let index = this.listOfTool.findIndex(t=>t.id == (this.mcpForm.get('url')?.value||this.mcpForm.get('idhook')?.value) );
            if ( index == -1 ){
                this.listOfTool.push({
                    id: (this.mcpForm.get('url')?.value||this.mcpForm.get('idhook')?.value),
                    tools: [toolNormalized]
                });
                
            }else{
                let localTool:any[] = this.listOfTool[index].tools;
                let toolIndex = localTool.findIndex(t=> t.name == toolNormalized.name);
                if ( toolIndex > -1 ){
                  localTool[toolIndex] = toolNormalized;
                }else{
                  localTool.push(toolNormalized);
                }
            }
        }
        this.filteredListOfTool = this.listOfTool.filter(d=>d.id == (this.mcpForm.get('url')?.value||this.mcpForm.get('idhook')?.value));
        this.loadingMcp = false;
    }).catch(error=>{
        this.loadingMcp = false;
        console.error('Erro ao buscar ferramentas:', error);
        this.message.error('Erro ao buscar ferramentas:' + GlobalErrorHandler.getMessage(error));
    });
  }



  /**
   * Salva MCP (novo ou atualizado)
   */
  saveMcp(): void {
    if (this.mcpForm.invalid) {
      let errors = this.formServices.getFormErrors(this.mcpForm,[],"\n", 'agentBuilder');
      this.message.error(errors);
      return;
    }

    if ( this.editingIndexMcp === -1){
        this.mcps = [...this.mcps, this.mcpForm.value];
    }else{
        this.mcps[this.editingIndexMcp] = this.mcpForm.value;
    }
    this.form.get('mcps')?.setValue(this.mcps);
    this.tableMcp.data = [...this.mcps];
    
    this.closeMcpModal();
  }

  deleteMcp(index): void {
    if (!index && index <0 ) {
      this.message.error('MCP inválido');
      return;
    }
    
    this.modal.confirm({
      nzTitle: 'Confirmar exclusão',
      nzContent: 'Tem certeza que deseja excluir este MCP?',
        nzOkText: 'Sim',
        nzCancelText: 'Não',
        nzOkDanger: true,
        nzOnOk: () => {
          this.mcps.splice(index, 1);
          this.tableMcp.data = [...this.mcps];
          this.form.get('mcps')?.setValue(this.mcps);

        }
    });
    
  }

  /**
   * Fecha modal
   */
  closeMcpModal(): void {
    this.showMcpModal = false;
    if ( this.localSub!=null){
      this.localSub.unsubscribe();
    }
  }

  /**
   * Abre input de arquivo
   */
  triggerFileInput(): void {
    this.fileInput.nativeElement.click();
  }


  /**
   * Formata data
   */
  formatDate(date?: Date): string {
    if (!date) return '-';
    return new Date(date).toLocaleDateString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  }

  
  /**
   * Salva agente
   */
  save(): void {
    if (this.form.invalid) {
      let errors = this.formServices.getFormErrors(this.form,[],"\n");
      this.message.error(errors);
      return;
    }

    const agentData:Agent = this.form.getRawValue() as Agent;

    this.loading = true;

    
    if ( !this.form.get("systemPrompt").pristine){
        let objectHistory = {
                systemPrompt:this.backupSystemPrompt,
                idUser:this.uas.user.iduser,
                userName: this.uas.user.username,
                updatedAt: new Date()
        };

        if (!agentData.systemPromptHistory) {
            agentData.systemPromptHistory = [objectHistory];
            } else {
            agentData.systemPromptHistory.push(objectHistory);
        }
    }

    const request = this.agent._id
      ? this.agentServiceV2.updateAgent(this.agent._id, agentData )
      : this.agentServiceV2.createAgent(agentData);

    request.subscribe({
      next: () => {
        this.loading = false;
        this.message.success(
          this.agent._id ? 'Agente atualizado com sucesso' : 'Agente criado com sucesso'
        );
        this.agentServiceV2.refreshAgents();
        this.form.markAsPristine();
        
      },
      error: (err) => {
        this.loading = false;
        console.error(err);
        this.message.error('Erro ao salvar agente:' + GlobalErrorHandler.getMessage(err));
      }
    });
  }

  closeConfig(): void {
    if ( !this.form.pristine){
      this.modal.confirm({
        nzTitle: 'Confirmar',
        nzContent: 'Deseja fechar a configuração? As alterações não salvas serão perdidas.',
          nzOkText: 'Sim',
          nzCancelText: 'Não',
          nzOnOk: () => {
            this.form.patchValue(this.oldForm);
            this.editSubject?.next(false);
            this.initMcpForm();
          }
      });
    } else {
      this.editSubject?.next(false);
    }
  }
 
  
  //HEADER DO MCP//

    newKey = '';
    newValue = '';

    addHeader() {
        if (!this.newKey) return;
        let arrayValues = this.mcpForm.get('header').value as any[];
        arrayValues = [...arrayValues, {key:this.newKey, value:this.newValue }];
        this.mcpForm.get('header').setValue(arrayValues);
        this.newKey = '';
        this.newValue = '';
    }

    removeHeader(index: number) {
        const headerArray = this.mcpForm.get('header').value as any[];
        headerArray.splice(index, 1);
        this.tableHHeader.data = [...headerArray];
        this.mcpForm.get('header').setValue(headerArray);
    }


    // goal table //

    newGoalItem;
    editGoalIndex: number | null = null;

    stopEdit() {
        this.editGoalIndex = null;
    }


    editGoal(i){
        this.editGoalIndex = i;
    }

    addGoal(){
        const v = this.newGoalItem.trim();
        if (!v) return;
        
        let arrayValues = this.form.get('goal').value as any[];
        arrayValues = [...arrayValues, v];
        this.form.get('goal').setValue(arrayValues);
        this.newGoalItem = '';

    }

    removeGoal(i){
        const goalArray = this.form.get('goal').value as any[];
        goalArray.splice(i, 1);
        this.tableGoal.data = [...goalArray];
        this.form.get('goal').setValue(goalArray);
    }

    openScheduleComponent(evento){
      
        evento.stopPropagation();

        let modalConfiguration:ModalOptions = {
            nzTitle: this.ls.instant('schedule'),
            nzContent: CronFormComponent,
            nzWidth:  '80%',
            nzClassName: 'modal-size-80',
            nzStyle: { 'top': '5px'},
            nzData: {
                action:{
                    value: this.form.get('cron').value,
                    showButtons: false
                }
            },  
            nzMask:false,
            nzOkText: this.ls.instant('OK'),
            nzCancelText: this.ls.instant('Cancel'),
            nzOnOk: (val)=>{
                
                this.form.get('cron').setValue(val);
            }, 
        }  

        let modalRef = this.modal.create(modalConfiguration);
    }
       

}